import {SidebarContributors as ContributorsComponent} from '@github-ui/code-view-sidebar/components/SidebarContributors'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarContributors({ownerLogin, repoName}: Props) {
  const {contributors} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!contributors) return null
  return <ContributorsComponent {...contributors} />
}
